const validarPermiso = (usuario, permiso, tipoAutorizacion) => {
    return (usuario != undefined && usuario.rol && usuario.rol.Permisos && usuario.rol.Permisos[permiso] && usuario.rol.Permisos[permiso].TipoAutorizacionID >= tipoAutorizacion);
}

export default validarPermiso
